import {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {KTSVG} from 'src/_metronic/helpers'
import {ActionIcon} from 'src/components'
import {HakAkses} from 'src/components/mikro/getHakAkses'

interface Props {
  index: number
  rowNumber: number
  item: {
    id: number
    name: string
    address: string
    province: {region_name: string}
    city: {city_name: string}
    phone: string
    email: string
    segment_name: string
    business_field: string
  }
  onEdit: () => void
  onDelete: () => void
}

export const RowData: FC<Props> = ({
  index,
  rowNumber,
  item: {id, name, address, province, city, phone, email, segment_name, business_field},
  onEdit,
  onDelete,
}) => {
  const {t} = useTranslation()
  const hakAkses = HakAkses()

  return (
    <tr key={id ?? index}>
      <td>{rowNumber}</td>

      <td>{name}</td>

      <td>{address}</td>

      <td>{city?.city_name}</td>

      <td>{province?.region_name}</td>

      <td>{phone}</td>

      <td>{email}</td>

      <td>{segment_name}</td>

      <td>{business_field}</td>

      <td>
        <div className='d-flex justify-content-center p-0'>
          {hakAkses?.update && (
            <ActionIcon
              className='me-2'
              title={t('ubah')}
              iconPath='/media/icons/duotune/pencil-fill.svg'
              onClick={onEdit}
            />
          )}

          {hakAkses?.delete && (
            <ActionIcon
              className='me-2'
              title={t('Hapus')}
              iconPath='/media/icons/duotune/trash-fill.svg'
              onClick={onDelete}
            />
          )}
        </div>
      </td>
    </tr>
  )
}
